import { render, staticRenderFns } from "./ContactAddOrUpdateDialog.vue?vue&type=template&id=7a5f4aaa&"
import script from "./ContactAddOrUpdateDialog.vue?vue&type=script&lang=js&"
export * from "./ContactAddOrUpdateDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports